import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyTrackingStateProps {
  onActivate: () => void;
}

export function EmptyTrackingState({ onActivate }: EmptyTrackingStateProps) {
  useLanguage();
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)] w-full">
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="mb-6 p-8 bg-primary/10 rounded-full">
          <Plus className="h-12 w-12 text-primary" />
        </div>
        
        <h2 className="text-2xl font-semibold mb-2">
          {translateInterfaceText("Você não possui nenhum Rastreamento ativo")}</h2>
        
        <p className="text-muted-foreground mb-6 max-w-md">
          {translateInterfaceText("Integre plataformas de pagamento e rastreie conversões dos seus vídeos de forma simples.")}</p>
        
        <Button 
          onClick={onActivate}
          size="lg"
          className="bg-[#2563EB] hover:bg-[#2563EB]/90 text-white"
        >
          {translateInterfaceText("Clique aqui e ative agora!")}</Button>
      </div>
    </div>
  );
}
